export const dataVisualizationsSelector = ({ admin }) =>
  admin.runDataVisualizations.dataVisualizations;

export const isFetchingdataVisualizationsSelector = ({ admin }) =>
  admin.runDataVisualizations.isFetchingDataVisualizations;
